import { ArrowUpRight } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "./Motion";
import { SERVICES } from "../data/content";
import { scrollToHash } from "../lib/smooth";

const Card = ({ s, primary }) => (
  <a
    href={`#${s.id}`}
    onClick={(e) => { e.preventDefault(); scrollToHash(`#${s.id}`); }}
    data-testid={`service-index-${s.id}`}
    className={`group relative flex h-full flex-col justify-between overflow-hidden border border-[#E5DFD5] p-7 transition-colors duration-500 sm:p-9 ${
      primary ? "bg-[#1A1816] text-[#FAF8F5] min-h-[420px]" : "bg-white hover:bg-[#F3EFEA] min-h-[200px]"
    }`}
  >
    {primary && <img src={s.cover || s.looks[0].src} alt="Organized closet with neatly folded and hanging clothes" className="absolute inset-0 h-full w-full object-cover opacity-35 transition-transform duration-[1400ms] group-hover:scale-105" />}
    <div className="relative flex items-start justify-between">
      <span className={`text-xs tracking-[0.28em] uppercase ${primary ? "text-[#E3D6BF]" : "text-[#8A6A3E]"}`}>{s.num} — {s.tag}</span>
      <ArrowUpRight className="h-6 w-6 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
    </div>
    <div className="relative mt-10">
      <h3 className={`font-display leading-[1.02] ${primary ? "text-4xl sm:text-6xl" : "text-3xl sm:text-4xl"}`}>{s.title}</h3>
      <p className={`mt-4 max-w-md text-base leading-relaxed ${primary ? "text-[#E9E3DA]" : "text-[#5E5953]"}`}>{s.lead}</p>
    </div>
  </a>
);

export const ServicesIntro = () => (
  <section id="services" className="mx-auto max-w-[1440px] px-5 pt-24 pb-10 sm:px-10 sm:pt-36" data-testid="services-intro">
    <div className="grid gap-10 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Eyebrow>Services</Eyebrow>
        <h2 className="mt-6 font-display text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
          <MaskLines lines={["Three ways", "to work together"]} />
        </h2>
      </div>
      <Reveal className="lg:col-span-6 lg:col-start-7 lg:pt-14" delay={0.1}>
        <p className="text-lg leading-relaxed text-[#5E5953]">
          Whether you are starting over, making the most of what you already own, or dressing as a pair — each service ends with a clear plan and complete outfits you can wear straight away.
        </p>
      </Reveal>
    </div>
    <div className="mt-14 grid gap-4 lg:grid-cols-2 lg:grid-rows-2">
      <Reveal className="lg:row-span-2"><Card s={SERVICES[0]} primary /></Reveal>
      <Reveal delay={0.1}><Card s={SERVICES[1]} /></Reveal>
      <Reveal delay={0.2}><Card s={SERVICES[2]} /></Reveal>
    </div>
  </section>
);
